"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcAccountHeader = exports.FieldsetAccountGeneral = void 0;
const FieldsetAccountGeneral_yaml_component_1 = __importDefault(require("./FieldsetAccountGeneral.yaml?component"));
exports.FieldsetAccountGeneral = FieldsetAccountGeneral_yaml_component_1.default;
const UcAccountHeader_yaml_component_1 = __importDefault(require("./UcAccountHeader.yaml?component"));
exports.UcAccountHeader = UcAccountHeader_yaml_component_1.default;
